'use strict';

var MarketAnalysisDemandAdjustmentItemDirective = function MarketAnalysisDemandAdjustmentItemDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/market-analysis-demand-adjustment-item.html'),
    controller: 'MarketAnalysisDemandAdjustmentItemController',
    scope: {
      chartId: '@',
      filterData: '=',
      current: '=',
      view: '=',
      hideItemIfSingleModelValue: '=',
      chartInCompareMode: '='
    },
    link: function link($scope) {
      $scope.$on('demand-adjustment:resetAndDisableNonCompareModeChart', $scope.resetAndDisableNonCompareModeModel);
    }
  };
};
MarketAnalysisDemandAdjustmentItemDirective.$inject = [];
module.exports = MarketAnalysisDemandAdjustmentItemDirective;